import { useEffect } from 'react';
export function useDocumentKeydown(callback) {
    useEffect(function () {
        document.addEventListener('keydown', callback);
        return function () {
            document.removeEventListener('keydown', callback);
        };
    }, [callback]);
}
//# sourceMappingURL=useDocumentKeydown.js.map